<template>
    <div>
        <div class="table-layout">
            <el-table :data="goodsAllocItemList" border style="width: 100%">
                <el-table-column prop="title" label="商品名称" width="150"></el-table-column>
                <el-table-column prop="catName" label="分类名称" width="150"></el-table-column>
                <el-table-column prop="brandName" label="品牌名称" width="120"></el-table-column>
                <el-table-column prop="quantity" label="配货数量" align="right" width="100">
                    <template slot-scope="rows">
                        <span>{{rows.row.quantity * rows.row.ioFlag}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="createTime" label="配货时间" width="180"></el-table-column>
                <el-table-column align="center" prop="desireArriveDate" label="要求到货时间" width="130"></el-table-column>
                <el-table-column prop="desc" label="商品说明"></el-table-column>
            </el-table>
        </div>
        <div class="block pagination-layout">
            <el-pagination background class="mt10" layout="total, sizes, prev, pager, next, jumper" v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"></el-pagination>
        </div>
    </div>
</template>


<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf';

    import goodsOrderApi from '../../api/goodsOrder'

    export default {
        name: 'swb-order-goods-alloc-details',
        desc: '机构配货详情',
        props: ['orderId', 'buyerShopId'],
        data: function () {
            return {
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                goodsAllocItemList: []
            }
        },
        created: function () {
            //
            this.pageSize = this.pageSizes.first();
            //
            this.getGoodsAllocItemList();
        },
        methods: {
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getGoodsAllocItemList();
            },
            getGoodsAllocItemList: function () {
                let self = this;
                let orderId = self.orderId;
                let buyerShopId = self.buyerShopId;

                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};
                filterItems.orderId = orderId;
                filterItems.buyerShopId = buyerShopId;
                postData.filterItems = filterItems;
                //
                let msgBoxDlg = MsgBox.loading();
                goodsOrderApi.getOrderGoodsAllocItemPagedListByOrderId(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type === "info") {
                        let data = result.data;
                        self.goodsAllocItemList = data.rows;
                        //
                        let pagination = data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pagesize = pagination.pageSize;
                    } else {
                        self.$message.error(result.message);
                    }
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/order/OrderGoodsAllocDetails.vue